import React from "react";
import CodeLevelTable from "./CodeLevelTable";

const CodeLevel = () => {
  return (
    <div>
      <CodeLevelTable />
    </div>
  );
};

export default CodeLevel;
